// import React from "react";
// import { motion } from "framer-motion";

// const testimonials = [
//   {
//     logo: "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
//     quote: `“Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita sequi cupiditate harum repellendus ipsum dignissimos? Officiis ipsam dolorum magnam assumenda.”`,
//     name: "Anderson Lima",
//     role: "Product Manager, Slack",
//   },
//   {
//     logo: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
//     quote: `“Tiranga Express made our move seamless. The team was professional and responsive. Highly recommend their logistics service!”`,
//     name: "Priya Sharma",
//     role: "HR Manager, Amazon India",
//   },
//   {
//     logo: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
//     quote: `“We saved both time and cost by comparing quotes using this platform. Booking a mover has never been easier!”`,
//     name: "Rohan Mehta",
//     role: "Operations Lead, Flipkart",
//   },
// ];

// const Testimonials = () => {
//   return (
//     <section className="py-16 bg-light text-dark">
//       <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
//         {/* Left content */}
//         <div>
//           <h2 className="text-4xl font-bold mb-4 text-primary">What our customers think</h2>
//           <p className="text-secondary text-lg mb-6">
//             Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus
//             commodi sint, similique cupiditate possimus suscipit delectus illum eos iure magnam!
//           </p>
//           {/* Dots */}
//           <div className="flex gap-2 mt-6">
//             <span className="w-10 h-1 bg-primary"></span>
//             <span className="w-10 h-1 bg-secondary"></span>
//             <span className="w-10 h-1 bg-accent"></span>
//             <span className="w-10 h-1 bg-dark"></span>
//             <span className="w-10 h-1 bg-gray-200"></span>
//           </div>
//         </div>

//         {/* Right content */}
//         <div className="relative h-80 w-full">
//           {testimonials.map((item, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 50, scale: 0.9 }}
//               animate={{ opacity: 1, y: 0, scale: 1 }}
//               transition={{ duration: 0.6, delay: index * 0.3 }}
//               className="absolute inset-0 bg-dark text-white p-8 rounded-xl shadow-lg"
//               style={{
//                 zIndex: testimonials.length - index,
//                 transform: `translateY(${index * 15}px)`,
//               }}
//             >
//               <img src={item.logo} alt="logo" className="w-10 mb-4" />
//               <p className="italic text-lg mb-6">{item.quote}</p>
//               <h4 className="font-bold text-white">{item.name}</h4>
//               <p className="text-sm text-gray-300">{item.role}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;


import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    logo: "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
    quote: `“Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita sequi cupiditate harum repellendus ipsum dignissimos? Officiis ipsam dolorum magnam assumenda.”`,
    name: "Anderson Lima",
    role: "Product Manager, Slack",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
    quote: `“Tiranga Express made our move seamless. The team was professional and responsive. Highly recommend their logistics service!”`,
    name: "Priya Sharma",
    role: "HR Manager, Amazon India",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    quote: `“We saved both time and cost by comparing quotes using this platform. Booking a mover has never been easier!”`,
    name: "Rohan Mehta",
    role: "Operations Lead, Flipkart",
  },
   {
    logo: "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
    quote: `“Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita sequi cupiditate harum repellendus ipsum dignissimos? Officiis ipsam dolorum magnam assumenda.”`,
    name: "Lima",
    role: "Product Manager, Slack",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
    quote: `“Tiranga Express made our move seamless. The team was professional and responsive. Highly recommend their logistics service!”`,
    name: "Sharma",
    role: "HR Manager, Amazon India",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    quote: `“We saved both time and cost by comparing quotes using this platform. Booking a mover has never been easier!”`,
    name: "Mehta",
    role: "Operations Lead, Flipkart",
  },
   {
    logo: "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
    quote: `“Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita sequi cupiditate harum repellendus ipsum dignissimos? Officiis ipsam dolorum magnam assumenda.”`,
    name: "Anderson",
    role: "Product Manager, Slack",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
    quote: `“Tiranga Express made our move seamless. The team was professional and responsive. Highly recommend their logistics service!”`,
    name: "Priya",
    role: "HR Manager, Amazon India",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    quote: `“We saved both time and cost by comparing quotes using this platform. Booking a mover has never been easier!”`,
    name: "Rohan Mehta",
    role: "Operations Lead, Flipkart",
  },
   {
    logo: "https://cdn-icons-png.flaticon.com/512/2111/2111615.png",
    quote: `“Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita sequi cupiditate harum repellendus ipsum dignissimos? Officiis ipsam dolorum magnam assumenda.”`,
    name: "Eima",
    role: "Product Manager, Slack",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
    quote: `“Tiranga Express made our move seamless. The team was professional and responsive. Highly recommend their logistics service!”`,
    name: "Araav",
    role: "HR Manager, Amazon India",
  },
  {
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    quote: `“We saved both time and cost by comparing quotes using this platform. Booking a mover has never been easier!”`,
    name: "Rohan Mehta",
    role: "Operations Lead, Flipkart",
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleClick = (index: number) => {
    setCurrent(index);
  };

  return (
    <section className="py-16 bg-light text-dark">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left content */}
        <div>
          <h2 className="text-4xl font-bold mb-4 text-primary">What our customers think</h2>
          <p className="text-secondary text-lg mb-6">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus
            commodi sint, similique cupiditate possimus suscipit delectus illum eos iure magnam!
          </p>

          {/* Progress Bars */}
          <div className="flex gap-3 mt-6">
            {testimonials.map((_, i) => (
              <div
                key={i}
                onClick={() => handleClick(i)}
                className="relative h-1 w-20 bg-gray-300 cursor-pointer overflow-hidden rounded"
              >
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: i === current ? "100%" : 0 }}
                  transition={{ duration: 3.6, ease: "easeInOut" }}
                  className="absolute h-full bg-primary"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Right stacked cards */}
        <div className="relative h-96 w-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, y: 30, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -20, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 bg-dark text-white p-8 rounded-xl shadow-lg"
            >
              <img
                src={testimonials[current].logo}
                alt="logo"
                className="w-10 mb-4"
              />
              <p className="italic text-lg mb-6">{testimonials[current].quote}</p>
              <h4 className="font-bold text-white">{testimonials[current].name}</h4>
              <p className="text-sm text-gray-300">{testimonials[current].role}</p>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
